"use strict";
/**
 * @file Created on 02/27/2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var ResourceLockResultStatus_1 = require("../enums/ResourceLockResultStatus");

var ResourceLockType_1 = require("../enums/ResourceLockType");

var ResourceLockResultDTO_1 = require("../model/ResourceLockResultDTO");

var ResourceLockResultDTOConverter_1 = require("./ResourceLockResultDTOConverter");
/**
 * @author Tomas Leity
 */


var ResourceLockResultDTOConverterImpl =
/*#__PURE__*/
function (_ResourceLockResultDT) {
  _inherits(ResourceLockResultDTOConverterImpl, _ResourceLockResultDT);

  function ResourceLockResultDTOConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, ResourceLockResultDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceLockResultDTOConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ResourceLockResultDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ResourceLockResultDTO_1.ResourceLockResultDTO(ResourceLockResultDTO_1.ResourceLockResultDTO.schema.assignee.valueOf(conversions.asObjectOpt(source, 'assignee', function (doc) {
        return _this2.userInfoConverter.toObject(doc, conversions);
      })), ResourceLockResultDTO_1.ResourceLockResultDTO.schema.status.valueOf(conversions.asEnum(source.status, ResourceLockResultStatus_1.ResourceLockResultStatus)), ResourceLockResultDTO_1.ResourceLockResultDTO.schema.resourceId.valueOf(source.resourceId), ResourceLockResultDTO_1.ResourceLockResultDTO.schema.resourceLockType.valueOf(conversions.asEnum(source.resourceLockType, ResourceLockType_1.ResourceLockType)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        assignee: conversions.asObjectOpt(source, 'assignee', function (userInfo) {
          return _this3.userInfoConverter.toDocument(userInfo, conversions);
        }),
        status: source.status,
        resourceId: source.resourceId,
        resourceLockType: source.resourceLockType
      };
    }
  }]);

  return ResourceLockResultDTOConverterImpl;
}(ResourceLockResultDTOConverter_1.ResourceLockResultDTOConverter);

ResourceLockResultDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], ResourceLockResultDTOConverterImpl);
exports.ResourceLockResultDTOConverterImpl = ResourceLockResultDTOConverterImpl;